export abstract class Exception<T extends string> implements Error {
    public stack:string = (<any>new Error()).stack;
	public userMessage?:string;

	constructor(
		public type:T, 
		public name:string,
		public message:string
	){}
}


// WEBPACK FOOTER //
// ./src/util/domain/exception.ts